import { BUSINESS } from "@/data/site";

export const WhatsAppFAB = () => {
  return (
    <a
      data-testid="whatsapp-fab"
      href={BUSINESS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escriu-nos per WhatsApp"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full shadow-xl hover:scale-105 transition-transform flex items-center justify-center w-14 h-14"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor" aria-hidden="true">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.13 6.744 3.05 9.376L1.05 31.36l6.16-1.968A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.824 32 16S24.826 0 16.004 0zm9.32 22.6c-.388 1.094-1.926 2-3.15 2.266-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.828s1.166-3.428 1.58-3.898c.34-.388.9-.564 1.438-.564.174 0 .33.008.472.016.414.018.622.042.896.696.34.81 1.16 2.81 1.258 3.014.1.204.166.444.034.754-.124.31-.234.45-.46.722-.226.272-.44.48-.666.772-.206.256-.44.532-.18.98.26.444 1.158 1.91 2.486 3.094 1.714 1.528 3.142 2.002 3.64 2.21.372.154.81.118 1.082-.172.346-.372.772-.99 1.206-1.598.31-.434.7-.488 1.108-.334.416.144 2.642 1.246 3.094 1.472.452.226.752.334.864.52.108.186.108 1.082-.28 2.176z" />
      </svg>
    </a>
  );
};
